<template>
  <div class="redisMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          v-model="cacheClusterId"
          :placeholder="$t('alarms.redis.filterByCacheClusterId')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['elasticache:redisMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableRedis from "../redis/TableRedis";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
var tableRedis = TableRedis;
export default {
  name: "RedisMonitorSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      cacheClusterId: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("cacheClusterId", this.cacheClusterId);
      tableRedis.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.redisMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/elasticache/redis/RedisMonitorSearch.vue